import { useState } from "react";
import "../../../App.css";
import Listdelete from "./ListDelete";

import Add from "./Add";
import { Container } from "react-bootstrap";

function Pirsomeem(props) {
  const { visible, mekhraz } = props;
  const [counter, setCounter] = useState(0);

  const increment = () => {
    setCounter(counter + 1);
  };

  if (!visible) return;
  return (
    <Container>
      <Add increment={increment} counter={counter} mekhraz={mekhraz} />
      <Listdelete
        increment={increment}
        counter={counter}
        setCounter={setCounter}
        mekhraz_id={mekhraz.id}
      />
    </Container>
  );
}

export default Pirsomeem;
